import React, { useEffect, useRef, useState } from 'react';
import styles from './TemplateItem.module.css';
import Input from '../../../Input/Input';

export default function TemplateItem({ index, name, templateKey, fileInfo, onUploaded, api }) {
	const inputRef = useRef(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(undefined);
	const [uploadedOk, setUploadedOk] = useState(false);


	const hasFile = Boolean(fileInfo?.link);
	const downloadLink = fileInfo?.link;
	const initialPeriod = fileInfo?.period;

	const [enabled, setEnabled] = useState(initialPeriod != null);
	const [period, setPeriod] = useState(
		initialPeriod == null ? '' : String(initialPeriod)
	);

	useEffect(() => {
		const p = fileInfo?.period;
		setEnabled(p != null);
		setPeriod(p == null ? '' : String(p));
	}, [fileInfo?.period]);

	const onChooseFile = () => {
		setError(undefined);
		inputRef.current?.click();
	};

	const showSuccess = (ms = 1500) => {
		setUploadedOk(true);
		setTimeout(() => setUploadedOk(false), ms);
	};

	const onFileChange = async (e) => {
		setError(undefined);
		const file = e.target.files?.[0];
		e.target.value = '';
		if (!file) return;

		const fd = new FormData();
		fd.append('file', file);
		fd.append('title', templateKey);

		setLoading(true);
		try {
			await api.post('/file_templates/', fd, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			if (onUploaded) await onUploaded();
			showSuccess(1500);
		} catch (err) {
			setError(err?.response?.data?.detail || err?.message || 'Ошибка при загрузке файла');
		} finally {
			setLoading(false);
		}
	};

	const renderButtonText = () => {
		if (loading) return 'Загрузка…';
		if (uploadedOk) return '✓ Загружен';
		return hasFile ? 'Заменить' : 'Загрузить';
	};

	const onSend = async (period) => {
		console.log(`Sending period for ${templateKey}:`, period);
		const payload = {
			title: templateKey,
			period: period
		};
		try {
			await api.patch('/file_templates/period', payload, {
				headers: { 'Content-Type': 'application/json' }
			});
		} catch (err) {
			setError(err?.response?.data?.detail || err?.message || 'Ошибка при отправке данных');
		}
	};

	function normalizeNonNegativeInt(value) {
		return value.replace(/\D/g, '');
	}

	const enable = async () => {
		setEnabled(true);
		setPeriod(0);
		await onSend(0);
		queueMicrotask(() => inputRef.current?.focus());
	};

	const disable = async () => {
		setEnabled(false);
		setPeriod('');
		await onSend(null);
	};

	const onToggle = async (e) => {
		const checked = e.target.checked;
		if (checked) {
			await enable();
		} else {
			await disable();
		}
	};

	const onChange = async (e) => {
		const next = normalizeNonNegativeInt(e.target.value);
		setPeriod(next);
		if (!enabled) return;
		await onSend(next === '' ? 0 : Number(next));
	};

	const blockBadKeys = (e) => {
		const blocked = ['e', 'E', '+', '-', '.', ',', ' '];
		if (blocked.includes(e.key)) e.preventDefault();
	};

	return (
		<tr className={styles.row}>
			<td className={styles.cellIndex}>{index}</td>
			<td className={styles.cellName}>{name}</td>
			<td className={styles.cellPeriod}>
				<label className={styles.periodWrap}>
					<input
						type="checkbox"
						checked={enabled}
						onChange={onToggle}
						className={styles.periodCheckbox}
					/>
					<Input
						ref={inputRef}
						className={styles.periodInput}
						type="number"
						disabled={!enabled}
						value={period}
						onKeyDown={blockBadKeys}
						onChange={onChange}
					/>
				</label>
			</td>
			<td className={styles.cellAction}>
				<input ref={inputRef} type="file" onChange={onFileChange} className={styles.hiddenInput} />
				<div
					onClick={!loading ? onChooseFile : undefined}
					className={`${styles.uploadIcon} ${loading ? styles.uploadIconDisabled : ''} ${uploadedOk ? styles.uploadedOkIcon : ''}`}
					title={renderButtonText()}
				>
					{loading ? (
						<span className={styles.loadingSpinner}>⏳</span>
					) : uploadedOk ? (
						<span className={styles.checkMark}>✓</span>
					) : (
						<img src="/icons/doc-add-icon.svg" alt={hasFile ? 'Заменить' : 'Загрузить'} className={styles.actionIcon} />
					)}
				</div>
				{error && <div className={styles.error}>{error}</div>}
			</td>
			<td className={styles.cellFile}>
				{hasFile ? (
					<a href={downloadLink} target="_blank" rel="noreferrer" className={styles.fileLink}>
						<img src="/icons/doc-icon.svg" alt="file" className={styles.iconActive} />
					</a>
				) : (
					<div className={styles.fileLinkDisabled} title="Файл не загружен">
						<img src="/icons/doc-icon.svg" alt="file" className={styles.iconDisabled} />
					</div>
				)}
			</td>
		</tr>
	);
}
